
import { ColorMatrix } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextField } from "@goodgamestudios/createjs-utilities";
import { TextFormat } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { BonusVO } from "../../../gamevo/BonusVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2LoginBonusDialogProperties } from "./Poker2LoginBonusDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import {Poker2LayoutManager} from "../../Poker2LayoutManager";

export class Poker2LoginBonusDialog4Days extends Poker2Dialog {
    public static NAME: string = "Poker2LoginBonusDialog4Days";

    private DAYS: number = 4;
    private DAY_ITEM_POS_Y: number = 67.45;
    private DAY_ITEM_POS_X_START: number = -386.15;//-231.7;
    private DAY_ITEM_POS_X_OFFSET: number = 154.45;

    private _mc_bonusType: MovieClip;
    private _currentIndex: number = 0;
    private currentBonus: any[];
    private _currentDay: number = 0;
    private colorMatrix: ColorMatrix;
    private _bonusVOs: BonusVO[];
    private _currentBonusType: number = 0;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this._mc_bonusType = this.loginDialog.mc_bonusType;

        // texts
        this.loginDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        this.loginDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_loginbonus_title");
        // You have logged in {0} days in a row.
        this.loginDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_loginbonus_copy_0", [this.bonusDialogProperties.loginDays]);
        // Your welcome bonus:
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.loginDialog.arrows.txt_arrow_copy, Poker2Model.languageData.getTextById("dialog_loginbonus_copy_1"), 2);

        // map day 1-3 to array indices 0-3
        if (this.bonusDialogProperties.loginDays % this.DAYS == 0) {
            this._currentIndex = this.DAYS - 1;
        }
        else {
            this._currentIndex = int((this.bonusDialogProperties.loginDays % this.DAYS) - 1);
        }

        this._currentDay = this._currentIndex + 1;

        // set all elements
        var i: number = 0;
        var len: number = this.DAYS;
        for (i = 1; i < this.DAYS + 1; ++i) {
            this.createDayItem(i);
            this.setDayTexts(i);
            this.setArrowsState(i);
        }
    }

    private createDayItem(dayId: number): void {
        var bonusVO: BonusVO = this.bonusDialogProperties.bonusVOs[dayId - 1];
        var amount1: string = "x ";
        var amount2: string = "x ";

        var tempDayItem: MovieClip;
        var tf1: TextField;
        var tf2: TextField;

        switch (bonusVO.bonusType) {
            case 1:

                tempDayItem = new Library.PokerPopUps.PokerDailyLoginBonus_4day_DayItem_1value();

                tf1 = tempDayItem.txt_amount;
                tf1.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;

                amount1 += NumberStringHelper.groupString(bonusVO.chips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
                TextFieldHelper.changeTextFromatSizeByTextWidth(this.FONT_SIZE_VALUES, tf1, amount1);
                break;

            case 2:

                tempDayItem = new Library.PokerPopUps.PokerDailyLoginBonus_4day_DayItem_2values();

                tempDayItem.bonusType.gotoAndStop(1);

                tf1 = tempDayItem.txt_amount1;
                tf2 = tempDayItem.txt_amount2;
                tf1.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
                tf2.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;

                amount1 += NumberStringHelper.groupString(bonusVO.chips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
                amount2 += NumberStringHelper.groupString(bonusVO.xp, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
                TextFieldHelper.changeTextFromatSizeByTextWidth(this.FONT_SIZE_VALUES, tf1, amount1);
                TextFieldHelper.changeTextFromatSizeByTextWidth(this.FONT_SIZE_VALUES, tf2, amount2);
                break;

            case 3:

                tempDayItem = new Library.PokerPopUps.PokerDailyLoginBonus_4day_DayItem_2values();

                tempDayItem.bonusType.gotoAndStop(2);

                tf1 = tempDayItem.txt_amount1;
                tf2 = tempDayItem.txt_amount2;
                tf1.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
                tf2.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;

                amount1 += NumberStringHelper.groupString(bonusVO.chips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
                amount2 += NumberStringHelper.groupString(bonusVO.gold, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
                TextFieldHelper.changeTextFromatSizeByTextWidth(this.FONT_SIZE_VALUES, tf1, amount1);
                TextFieldHelper.changeTextFromatSizeByTextWidth(this.FONT_SIZE_VALUES, tf2, amount2);
                break;
        }

        tempDayItem.x = this.DAY_ITEM_POS_X_START + (dayId * this.DAY_ITEM_POS_X_OFFSET);
        tempDayItem.y = this.DAY_ITEM_POS_Y;

        this.loginDialog.dayItemHolder.addChild(tempDayItem);

        if (dayId == this._currentDay) {
            // highlight
            tempDayItem.gotoAndStop(2);
        }
        else {
            // blur
            tempDayItem.gotoAndStop(1);
        }

        // correct arrows text position for day 3
        if (this._currentDay == 3) {
            this.loginDialog.arrows.txt_arrow_copy.x = 390 - this.loginDialog.arrows.txt_arrow_copy.width;
        }
    }

    private setDayItemState(dayId: number): void {
        var tempDayItem: MovieClip = this.loginDialog["dayItem" + dayId];

        if (dayId == this._currentDay) {
            // highlight
            tempDayItem.gotoAndStop(2);
        }
        else {
            // blur
            tempDayItem.gotoAndStop(1);
        }
    }

    private setArrowsState(dayId: number): void {
        if (dayId == this._currentDay) {
            this.loginDialog.arrows.gotoAndStop(dayId);
        }
    }

    public static TXT_FORMAT_HIGHLIGHT: TextFormat;
    public static TXT_FORMAT_NORMAL: TextFormat;
    private FONT_SIZE_VALUES: number = 12.5;

    private setDayTexts(dayId: number): void {
        var tempLabel: TextField = this.loginDialog["txt_day_" + dayId + "_label"];
        var tempValue: TextField = this.loginDialog["txt_day_" + dayId + "_dayCount"];

        // set label
        tempLabel.text = Poker2Model.languageData.getTextById("dialog_loginbonus_day_new");
        tempValue.text = (this.bonusDialogProperties.loginDays - (this._currentDay - dayId)).toString();

        if (dayId == this._currentDay) {
            // highlight
            tempLabel.textColor = Poker2LoginBonusDialog4Days.TXT_FORMAT_HIGHLIGHT.color;
            tempValue.textColor = Poker2LoginBonusDialog4Days.TXT_FORMAT_HIGHLIGHT.color;
        }
        else {
            // blur
            tempLabel.textColor = Poker2LoginBonusDialog4Days.TXT_FORMAT_NORMAL.color;
            tempValue.textColor = Poker2LoginBonusDialog4Days.TXT_FORMAT_NORMAL.color;
        }
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.loginDialog.btn_ok:
            case this.loginDialog.btn_close:
                this.hide();
                break;
        }
    }

    protected get bonusDialogProperties(): Poker2LoginBonusDialogProperties {
        return this.properties as Poker2LoginBonusDialogProperties;
    }

    protected get loginDialog(): Library.PokerPopUps.PokerDailyLoginBonus_4day_period {
        return this.disp as Library.PokerPopUps.PokerDailyLoginBonus_4day_period;
    }

    public static __initialize_static_members() {
        Poker2LoginBonusDialog4Days.TXT_FORMAT_HIGHLIGHT = new TextFormat(null, null, 0xFF4F03);
        Poker2LoginBonusDialog4Days.TXT_FORMAT_NORMAL = new TextFormat(null, null, 0xffffff);
    }
}
Poker2LoginBonusDialog4Days.__initialize_static_members();
